import { useEffect, useState } from 'react';
import { List } from 'react-admin';
import { AdsIngestRunsDataGrid } from './AdsIngestRunsDataGrid';
import { IngestRunsSummary } from './components/IngestRunsSummary';
import { TablePagination } from '../../../helperComponents/TablePagination';
import { TitleAboveTable } from '../../../helperComponents/TitleAboveTable';
import { ToolBarRowStyleToggle } from '../../../helperComponents/ToolBarRowStyleToggle';
import { getAdsIngestRunsFilters } from './helpers/adsIngestRunsFilters';
import { fetchAdsIngestRunsSummary } from '../../../../api';
import { getDefaultReceivedFrom } from '../../../../helpers/adsIngestRunsHelpers';

export const AdsIngestRunsList = (props) => {
  const [summary, setSummary] = useState(null);
  const [summaryError, setSummaryError] = useState(false);

  // The industry switch reloads the page, so one fetch per mount follows the selected industry
  useEffect(() => {
    fetchAdsIngestRunsSummary().then(setSummary).catch(() => setSummaryError(true));
  }, []);

  return (
    <>
      <TitleAboveTable title="Data Deliveries" />
      <IngestRunsSummary summary={summary} error={summaryError} />
      <List
        {...props}
        title=" "
        actions={<ToolBarRowStyleToggle showSelectColumnsButton showExportButton={false} />}
        pagination={<TablePagination />}
        filters={getAdsIngestRunsFilters(summary)}
        filterDefaultValues={{ received_from: getDefaultReceivedFrom() }}
        sort={{ field: 'received_at', order: 'DESC' }}
      >
        <AdsIngestRunsDataGrid />
      </List>
    </>
  );
};
